export const PUBLIC_WEBSITE_DEFAULTS = {
  heroEyebrow: 'Learning starts here',
  heroTitle: '',
  heroAccent: '',
  heroDescription: '',
  heroImageURL: '',
  heroImageAlt: '',
  heroImagePosition: 'center center',
  heroPrimaryAction: 'Apply Now',
  heroSecondaryAction: 'Student Login',
  heroTertiaryAction: 'Watch how it works',
  heroNote: '',
  heroTrust: 'Designed for every way of learning',
  modernHero: {
    artNoteLine1: 'More clarity for',
    artNoteLine2: "every learner's",
    artNoteEmphasis: 'next step.',
    courseBadgeLabel: 'courses',
    courseBadgeSuffix: 'ready to explore',
    courseBadgeCountFallback: 'Open',
    admissionsStatus: 'Admissions are open',
    heroNoteFallback: 'Publish your first course to showcase it here.',
    imageAlt: 'Learners building their next step together',
    stat1Label: 'Courses',
    stat1Hint: 'Publicly visible',
    stat2Label: 'Intakes',
    stat2Hint: 'Open and cohort',
    stat3Label: 'Session blocks',
    stat3Hint: 'Flexible schedules',
  },
  modernNavigation: {
    homeLabel: 'Home',
    aboutLabel: 'About us',
    coursesLabel: 'Courses',
    contactLabel: 'Contact us',
  },
  minimalNavigation: {
    homeLabel: 'Home',
    aboutLabel: 'About us',
    coursesLabel: 'Courses',
    contactLabel: 'Contact us',
  },
  minimalHero: {
    eyebrow: 'Learn with purpose',
    title: '',
    accent: 'course',
    description: 'A focused learning experience that helps every learner take the next step with confidence.',
    imageURL: '',
    imageURL2: '',
    imageURL3: '',
    imagePosition: 'center center',
    primaryAction: 'Explore courses',
    secondaryAction: 'See how it works',
    imageAlt: 'Learners learning with purpose',
    imageAlt2: 'Learner growing with confidence',
    imageAlt3: 'Learner exploring a new path',
    stat1Label: 'Courses',
    stat1Hint: 'Publicly visible',
    stat2Label: 'Intakes',
    stat2Hint: 'Open and cohort',
    stat3Label: 'Session blocks',
    stat3Hint: 'Flexible schedules',
    shapeCyan: '#19c5e7',
    shapePurple: '#5b43c5',
    shapeYellow: '#f8bd3d',
    shapeRed: '#e72c2c',
  },
  classicHero: {
    eyebrow: 'Learning platform',
    title: '',
    accent: 'for a brighter future.',
    description: 'A polished front-facing academy site for applications, course discovery, and student login.',
    imageURL: '',
    imageURL2: '',
    imageURL3: '',
    imageURL4: '',
    imagePosition: 'center center',
    primaryAction: 'Explore courses',
    secondaryAction: 'Student login',
    featuredLabel: 'Featured course',
    featuredAction: 'Apply to featured course',
  },
  aboutEyebrow: 'About us',
  aboutTitle: 'A clear first step for every learner.',
  aboutDescription: '',
  aboutBody: 'Every learner should know where they are, what comes next, and how to begin.',
  aboutImageURL: '',
  aboutBullets: [
    'Discover what your academy offers at a glance.',
    'Choose a course, intake, and session with confidence.',
    'Apply once, then return through a personal student account.',
  ],
  classicAbout: {
    eyebrow: 'About us',
    title: 'A clear first step for every learner.',
    description: '',
    imageURL: '',
    highlights: [
      'Discover what your academy offers at a glance.',
      'Choose a course, intake, and session with confidence.',
      'Apply once, then return through a personal student account.',
    ],
    rateLabelLine1: 'Average class',
    rateLabelLine2: 'completion rate',
    rateChange: '↑ 4.5%',
    rateValue: '87%',
    firstStatLine1: 'Courses built around',
    firstStatLine2: 'your next step',
    secondStatLine1: 'Ways to begin',
    secondStatLine2: 'learning with us',
  },
  modernAbout: {
    eyebrow: 'About us',
    title: 'A clear first step for every learner.',
    description: 'Bring your courses, story and admissions flow together in one clear public home.',
    body: 'Every learner should know where they are, what comes next, and how to begin.',
    imageURL: '',
    imageAlt: 'Learners building their next step together',
    imagePosition: 'center center',
    bullets: [
      'Discover what your academy offers at a glance.',
      'Choose a course, intake, and session with confidence.',
      'Apply once, then return through a personal student account.',
    ],
    asideNumber: '01',
    asideTitle: 'People first. Always.',
    asideDescription: 'From the first visit to the first lesson, every detail should help a learner feel ready to belong.',
    principles: [
      { title: 'Admissions flow', description: 'Keep the path from browsing to applying short and clear.' },
      { title: 'Flexible sessions', description: 'Use open intakes, cohorts, and recurring class schedules.' },
      { title: 'Course first', description: 'Lead with the courses students can actually join today.' },
    ],
  },
  minimalAbout: {
    eyebrow: 'About us',
    title: 'A clear first step for every learner.',
    description: 'Bring your courses, story and admissions flow together in one clear public home.',
    imageURL: '',
    imageAlt: 'Learner studying with confidence',
    imagePosition: 'center center',
    learningPathsLabel: 'learning paths',
    bullets: [
      'Discover what your academy offers at a glance.',
      'Choose a course, intake, and session with confidence.',
      'Apply once, then return through a personal student account.',
    ],
    primaryAction: 'Explore courses',
    secondaryAction: 'See how it works',
  },
  aboutAsideTitle: 'People first. Always.',
  aboutAsideDescription: 'From the first visit to the first lesson, every detail should help a learner feel ready to belong.',
  principles: [
    { title: 'Admissions flow', description: 'Keep the path from browsing to applying short and clear.' },
    { title: 'Flexible sessions', description: 'Use open intakes, cohorts, and recurring class schedules.' },
    { title: 'Course first', description: 'Lead with the courses students can actually join today.' },
  ],
  benefits: [
    { title: 'Courses from people who care', description: 'Learn in a welcoming space with guidance that keeps your next step clear.' },
    { title: 'Quality learning that lasts', description: 'Build practical skills through thoughtful lessons, useful feedback, and steady practice.' },
    { title: 'Learn at your own rhythm', description: 'Return to your learning when it suits you and keep your progress moving forward.' },
  ],
  minimalBenefits: {
    cards: [
      { title: 'Courses from people who care', description: 'Learn in a welcoming space with guidance that keeps your next step clear.', iconBackground: '#fff2ec', iconColor: '#fa4b12' },
      { title: 'Quality learning that lasts', description: 'Build practical skills through thoughtful lessons, useful feedback, and steady practice.', iconBackground: '#eafcff', iconColor: '#19a9c7' },
      { title: 'Learn at your own rhythm', description: 'Return to your learning when it suits you and keep your progress moving forward.', iconBackground: '#fff1f1', iconColor: '#e72c2c' },
    ],
  },
  whyTitle: 'Why study with us?',
  whyCards: [
    { title: 'Learn with a clear purpose', description: 'Move from the first lesson to a meaningful next step with a learning path that makes progress easier to see.' },
    { title: 'Learning that fits real life', description: 'Study at a pace that works for you, with course information and support available when you need it.' },
    { title: 'Support that feels human', description: 'Ask questions, get guidance, and learn alongside a community that wants you to do well.' },
    { title: 'Build skills by doing', description: 'Turn ideas into confident practice through useful lessons, thoughtful feedback, and work you can be proud of.' },
  ],
  whyImageURL: '',
  whyImageURL2: '',
  classicWhy: {
    title: 'Why study with us?',
    cards: [
      { title: 'Learn with a clear purpose', description: 'Move from the first lesson to a meaningful next step with a learning path that makes progress easier to see.', color: '#fa4b12', textColor: '#ffffff' },
      { title: 'Learning that fits real life', description: 'Study at a pace that works for you, with course information and support available when you need it.', color: '#3773ed', textColor: '#ffffff' },
      { title: 'Support that feels human', description: 'Ask questions, get guidance, and learn alongside a community that wants you to do well.', color: '#e8e2d9', textColor: '#111111' },
      { title: 'Build skills by doing', description: 'Turn ideas into confident practice through useful lessons, thoughtful feedback, and work you can be proud of.', color: '#5a112d', textColor: '#ffffff' },
    ],
    imageURL: '',
    imageURL2: '',
    imageAlt: 'Learner studying with confidence',
    imageAlt2: 'Learner building new skills',
  },
  coursesEyebrow: 'Courses',
  coursesTitle: 'Find the right path forward.',
  coursesDescription: 'Choose a learning path that fits where you are and where you want to go next.',
  courseAlignment: 'left',
  classicCourses: {
    cardBadgeFallback: '42K',
    programmeFallback: 'Learning programme',
    durationFallback: 'Flexible duration',
    ratingStars: '★ ★ ★ ★',
    ratingFallback: '4.5',
    cardAction: 'Explore course',
  },
  modernCourses: {
    eyebrow: 'Courses',
    title: 'Find the right path forward.',
    description: 'Choose a learning path that fits where you are and where you want to go next.',
    alignment: 'left',
    singleCourseSuffix: 'course ready to explore.',
    multipleCourseSuffix: 'paths ready to explore.',
    emptyCountLabel: 'Your',
    courseBadgeFallback: 'Featured course',
    descriptionFallback: 'Signup is open for this course.',
    durationFallback: 'Flexible duration',
    cardAction: 'Apply Now',
    emptyTitle: 'No public courses yet.',
    emptyMessage: 'This academy has not published courses for public signup.',
  },
  minimalCourses: {
    eyebrow: 'Courses',
    title: 'Find the right path forward.',
    description: 'Choose a learning path that fits where you are and where you want to go next.',
    alignment: 'left',
    durationFallback: 'Flexible',
    codeFallback: 'Learning path',
    descriptionFallback: 'Signup is open for this course.',
    intakeSingular: 'intake',
    intakePlural: 'intakes',
    openIntakeLabel: 'Open intake',
    cardAction: 'Explore courses',
    emptyTitle: 'No public courses yet.',
    emptyMessage: 'This academy has not published courses for public signup.',
  },
  contactEyebrow: 'Contact us',
  contactTitle: 'Questions? We’re here to help.',
  contactDescription: 'Make it easy for families to ask, understand, and take the next step.',
  contactEmail: '',
  contactPhone: '',
  contactLocation: '',
  classicContact: {
    eyebrow: 'Contact us',
    title: 'Questions? We’re here to help.',
    description: 'Make it easy for families to ask, understand, and take the next step.',
    emailLabel: 'Admissions email',
    emailHint: 'Shown to prospective students.',
    phoneLabel: 'Phone number',
    phoneHint: 'Good for fast follow-up.',
    locationLabel: 'Location',
    locationHint: 'Campus or virtual office.',
    ctaEyebrow: 'Ready when you are',
    ctaTitle: 'Begin the next chapter.',
    ctaDescription: 'Explore the courses, find the right fit, and take the next step with support from our team.',
    primaryAction: 'Explore courses',
    secondaryAction: 'Student login',
  },
  modernContact: {
    eyebrow: 'Contact us',
    title: 'Questions? We’re here to help.',
    description: 'Make it easy for families to ask, understand, and take the next step.',
    emailLabel: 'Admissions email',
    emailHint: 'Shown to prospective students.',
    phoneLabel: 'Phone number',
    phoneHint: 'Good for fast follow-up.',
    locationLabel: 'Location',
    locationHint: 'Campus or virtual office.',
    ctaEyebrow: 'Ready when you are',
    ctaTitle: 'Begin the next chapter.',
    ctaDescription: 'Explore the courses, find the right fit, and take the next step with support from our team.',
    primaryAction: 'Apply Now',
    secondaryAction: 'Student Login',
  },
  minimalContact: {
    eyebrow: 'Contact us',
    title: 'Questions? We’re here to help.',
    description: 'Make it easy for families to ask, understand, and take the next step.',
    detailsHeading: 'Find us here',
    emailLabel: 'Admissions email',
    emailHint: 'Shown to prospective students.',
    phoneLabel: 'Phone number',
    phoneHint: 'Good for fast follow-up.',
    locationLabel: 'Location',
    locationHint: 'Campus or virtual office.',
    primaryAction: 'Explore courses',
    secondaryAction: 'Student login',
    orbText: '?',
  },
  contactCtaEyebrow: 'Ready when you are',
  contactCtaTitle: 'Begin the next chapter.',
  contactCtaDescription: 'Explore the courses, find the right fit, and take the next step with support from our team.',
  footerEyebrow: 'Your next chapter starts here',
  footerTitle: 'Ready to begin?',
  footerDescription: 'Discover the right course, ask a question, or take the first step with your academy.',
  footerAction: 'Start your application',
  footer: {
    eyebrow: 'Your next chapter starts here',
    title: 'Ready to begin?',
    description: 'Discover the right course, ask a question, or take the first step with your academy.',
    action: 'Start your application',
    navigationHeading: 'Explore',
    homeLabel: 'Home',
    aboutLabel: 'About us',
    coursesLabel: 'Courses',
    contactLabel: 'Contact us',
    secondaryHeading: 'Connect',
    secondaryEmailText: '',
    secondaryPhoneText: '',
    secondaryLoginLabel: 'Student login',
    learnerHeading: 'For learners',
    learnerCoursesLabel: 'Find a course',
    learnerLoginLabel: 'Log in',
    learnerContactLabel: 'Ask a question',
    modernBottomText: '',
    classicBottomText: '',
    minimalMetaText: '',
    minimalTagline: 'Learn with purpose.',
    portalTypeText: '',
    poweredByLabel: 'Powered by Smart Campus Africa',
  },
  footerBackgroundColor: '#111111',
  footerTextColor: '#ffffff',
  pageBackgroundColor: '#f5f7f6',
  surfaceColor: '#ffffff',
  headingColor: '#111111',
  bodyColor: '#77726e',
};

function mergeList(defaultItems, savedItems, keys) {
  if (!Array.isArray(savedItems)) return defaultItems;
  return defaultItems.map((defaultItem, index) => {
    const savedItem = savedItems[index];
    const normalizedItem = typeof savedItem === 'string' ? { [keys[0]]: savedItem } : savedItem || {};
    return { ...defaultItem, ...normalizedItem };
  });
}

export function getPublicWebsiteContent(savedWebsite = {}) {
  const website = { ...PUBLIC_WEBSITE_DEFAULTS, ...(savedWebsite || {}) };
  Object.keys(PUBLIC_WEBSITE_DEFAULTS).forEach((field) => {
    if (typeof PUBLIC_WEBSITE_DEFAULTS[field] === 'string' && typeof website[field] !== 'string') {
      website[field] = PUBLIC_WEBSITE_DEFAULTS[field];
    }
  });
  if (!['left center', 'center center', 'right center', 'center top', 'center bottom'].includes(website.heroImagePosition)) website.heroImagePosition = 'center center';
  if (!['left', 'center', 'right'].includes(website.courseAlignment)) website.courseAlignment = 'left';
  website.classicCourses = { ...PUBLIC_WEBSITE_DEFAULTS.classicCourses, ...(savedWebsite?.classicCourses || {}) };
  const savedModernHero = savedWebsite?.modernHero || {};
  website.modernHero = {
    ...PUBLIC_WEBSITE_DEFAULTS.modernHero,
    heroNoteFallback: savedModernHero.heroNoteFallback ?? (website.heroNote || PUBLIC_WEBSITE_DEFAULTS.modernHero.heroNoteFallback),
    imageAlt: savedModernHero.imageAlt ?? website.heroImageAlt,
    stat1Label: savedModernHero.stat1Label ?? PUBLIC_WEBSITE_DEFAULTS.modernHero.stat1Label,
    stat1Hint: savedModernHero.stat1Hint ?? PUBLIC_WEBSITE_DEFAULTS.modernHero.stat1Hint,
    stat2Label: savedModernHero.stat2Label ?? PUBLIC_WEBSITE_DEFAULTS.modernHero.stat2Label,
    stat2Hint: savedModernHero.stat2Hint ?? PUBLIC_WEBSITE_DEFAULTS.modernHero.stat2Hint,
    stat3Label: savedModernHero.stat3Label ?? PUBLIC_WEBSITE_DEFAULTS.modernHero.stat3Label,
    stat3Hint: savedModernHero.stat3Hint ?? PUBLIC_WEBSITE_DEFAULTS.modernHero.stat3Hint,
    ...savedModernHero,
  };
  website.modernNavigation = { ...PUBLIC_WEBSITE_DEFAULTS.modernNavigation, ...(savedWebsite?.modernNavigation || {}) };
  const savedMinimalHero = savedWebsite?.minimalHero || {};
  website.minimalHero = {
    ...PUBLIC_WEBSITE_DEFAULTS.minimalHero,
    eyebrow: savedMinimalHero.eyebrow ?? website.heroEyebrow,
    title: savedMinimalHero.title ?? website.heroTitle,
    accent: savedMinimalHero.accent ?? (website.heroAccent || PUBLIC_WEBSITE_DEFAULTS.minimalHero.accent),
    description: savedMinimalHero.description ?? website.heroDescription,
    imageURL: savedMinimalHero.imageURL ?? website.heroImageURL,
    imagePosition: savedMinimalHero.imagePosition ?? website.heroImagePosition,
    primaryAction: savedMinimalHero.primaryAction ?? website.heroPrimaryAction,
    secondaryAction: savedMinimalHero.secondaryAction ?? website.heroTertiaryAction,
    imageAlt: savedMinimalHero.imageAlt ?? website.heroImageAlt ?? PUBLIC_WEBSITE_DEFAULTS.minimalHero.imageAlt,
    imageAlt2: savedMinimalHero.imageAlt2 ?? PUBLIC_WEBSITE_DEFAULTS.minimalHero.imageAlt2,
    imageAlt3: savedMinimalHero.imageAlt3 ?? PUBLIC_WEBSITE_DEFAULTS.minimalHero.imageAlt3,
    stat1Label: savedMinimalHero.stat1Label ?? PUBLIC_WEBSITE_DEFAULTS.minimalHero.stat1Label,
    stat1Hint: savedMinimalHero.stat1Hint ?? PUBLIC_WEBSITE_DEFAULTS.minimalHero.stat1Hint,
    stat2Label: savedMinimalHero.stat2Label ?? PUBLIC_WEBSITE_DEFAULTS.minimalHero.stat2Label,
    stat2Hint: savedMinimalHero.stat2Hint ?? PUBLIC_WEBSITE_DEFAULTS.minimalHero.stat2Hint,
    stat3Label: savedMinimalHero.stat3Label ?? PUBLIC_WEBSITE_DEFAULTS.minimalHero.stat3Label,
    stat3Hint: savedMinimalHero.stat3Hint ?? PUBLIC_WEBSITE_DEFAULTS.minimalHero.stat3Hint,
    ...savedMinimalHero,
  };
  if (!['left center', 'center center', 'right center', 'center top', 'center bottom'].includes(website.minimalHero.imagePosition)) website.minimalHero.imagePosition = 'center center';
  website.minimalNavigation = { ...PUBLIC_WEBSITE_DEFAULTS.minimalNavigation, ...(savedWebsite?.minimalNavigation || {}) };
  const savedClassicHero = savedWebsite?.classicHero || {};
  website.classicHero = { ...PUBLIC_WEBSITE_DEFAULTS.classicHero, ...savedClassicHero };
  ['title', 'description', 'imageURL'].forEach((field) => {
    if (!Object.prototype.hasOwnProperty.call(savedClassicHero, field) && savedWebsite?.[`hero${field.charAt(0).toUpperCase()}${field.slice(1)}`]) {
      website.classicHero[field] = savedWebsite[`hero${field.charAt(0).toUpperCase()}${field.slice(1)}`];
    }
  });
  if (!['left center', 'center center', 'right center', 'center top', 'center bottom'].includes(website.classicHero.imagePosition)) website.classicHero.imagePosition = 'center center';
  website.aboutBullets = Array.isArray(savedWebsite?.aboutBullets)
    ? savedWebsite.aboutBullets.slice(0, 3).map((item, index) => item || PUBLIC_WEBSITE_DEFAULTS.aboutBullets[index])
    : PUBLIC_WEBSITE_DEFAULTS.aboutBullets;
  const savedClassicAbout = savedWebsite?.classicAbout || {};
  website.classicAbout = {
    ...PUBLIC_WEBSITE_DEFAULTS.classicAbout,
    eyebrow: savedClassicAbout.eyebrow ?? website.aboutEyebrow,
    title: savedClassicAbout.title ?? website.aboutTitle,
    description: savedClassicAbout.description ?? website.aboutDescription,
    imageURL: savedClassicAbout.imageURL ?? website.aboutImageURL,
    highlights: Array.isArray(savedClassicAbout.highlights) ? savedClassicAbout.highlights : website.aboutBullets,
    ...savedClassicAbout,
  };
  website.classicAbout.highlights = PUBLIC_WEBSITE_DEFAULTS.classicAbout.highlights.map((defaultItem, index) => website.classicAbout.highlights[index] || defaultItem);
  const savedModernAbout = savedWebsite?.modernAbout || {};
  website.modernAbout = {
    ...PUBLIC_WEBSITE_DEFAULTS.modernAbout,
    eyebrow: savedModernAbout.eyebrow ?? website.aboutEyebrow,
    title: savedModernAbout.title ?? website.aboutTitle,
    description: savedModernAbout.description ?? (website.aboutDescription || PUBLIC_WEBSITE_DEFAULTS.modernAbout.description),
    body: savedModernAbout.body ?? website.aboutBody,
    imageURL: savedModernAbout.imageURL ?? website.aboutImageURL,
    bullets: Array.isArray(savedModernAbout.bullets) ? savedModernAbout.bullets : website.aboutBullets,
    asideTitle: savedModernAbout.asideTitle ?? website.aboutAsideTitle,
    asideDescription: savedModernAbout.asideDescription ?? website.aboutAsideDescription,
    principles: mergeList(PUBLIC_WEBSITE_DEFAULTS.modernAbout.principles, Array.isArray(savedModernAbout.principles) ? savedModernAbout.principles : savedWebsite?.principles, ['title', 'description']),
    ...savedModernAbout,
  };
  website.modernAbout.bullets = PUBLIC_WEBSITE_DEFAULTS.modernAbout.bullets.map((defaultItem, index) => website.modernAbout.bullets[index] || defaultItem);
  if (!['left center', 'center center', 'right center', 'center top', 'center bottom'].includes(website.modernAbout.imagePosition)) website.modernAbout.imagePosition = 'center center';
  const savedMinimalAbout = savedWebsite?.minimalAbout || {};
  website.minimalAbout = {
    ...PUBLIC_WEBSITE_DEFAULTS.minimalAbout,
    eyebrow: savedMinimalAbout.eyebrow ?? website.aboutEyebrow,
    title: savedMinimalAbout.title ?? website.aboutTitle,
    description: savedMinimalAbout.description ?? (website.aboutDescription || PUBLIC_WEBSITE_DEFAULTS.minimalAbout.description),
    imageURL: savedMinimalAbout.imageURL ?? website.aboutImageURL,
    bullets: Array.isArray(savedMinimalAbout.bullets) ? savedMinimalAbout.bullets : website.aboutBullets,
    primaryAction: savedMinimalAbout.primaryAction ?? website.minimalHero.primaryAction,
    secondaryAction: savedMinimalAbout.secondaryAction ?? website.minimalHero.secondaryAction,
    ...savedMinimalAbout,
  };
  website.minimalAbout.bullets = PUBLIC_WEBSITE_DEFAULTS.minimalAbout.bullets.map((defaultItem, index) => website.minimalAbout.bullets[index] || defaultItem);
  if (!['left center', 'center center', 'right center', 'center top', 'center bottom'].includes(website.minimalAbout.imagePosition)) website.minimalAbout.imagePosition = 'center center';
  website.principles = mergeList(PUBLIC_WEBSITE_DEFAULTS.principles, savedWebsite?.principles, ['title', 'description']);
  website.benefits = mergeList(PUBLIC_WEBSITE_DEFAULTS.benefits, savedWebsite?.benefits, ['title', 'description']);
  const savedMinimalBenefits = savedWebsite?.minimalBenefits || {};
  website.minimalBenefits = {
    ...PUBLIC_WEBSITE_DEFAULTS.minimalBenefits,
    cards: Array.isArray(savedMinimalBenefits.cards) ? savedMinimalBenefits.cards : website.benefits,
    ...savedMinimalBenefits,
  };
  website.minimalBenefits.cards = PUBLIC_WEBSITE_DEFAULTS.minimalBenefits.cards.map((defaultItem, index) => {
    const savedItem = website.minimalBenefits.cards[index];
    return {
      ...defaultItem,
      ...(typeof savedItem === 'string' ? { title: savedItem } : savedItem || {}),
    };
  });
  website.whyCards = mergeList(PUBLIC_WEBSITE_DEFAULTS.whyCards, savedWebsite?.whyCards, ['title', 'description']);
  const savedClassicWhy = savedWebsite?.classicWhy || {};
  website.classicWhy = {
    ...PUBLIC_WEBSITE_DEFAULTS.classicWhy,
    title: savedClassicWhy.title ?? website.whyTitle,
    cards: Array.isArray(savedClassicWhy.cards) ? savedClassicWhy.cards : website.whyCards,
    imageURL: savedClassicWhy.imageURL ?? website.whyImageURL,
    imageURL2: savedClassicWhy.imageURL2 ?? website.whyImageURL2,
    ...savedClassicWhy,
  };
  const savedClassicWhyCards = Array.isArray(website.classicWhy.cards) ? website.classicWhy.cards : [];
  website.classicWhy.cards = PUBLIC_WEBSITE_DEFAULTS.classicWhy.cards.map((defaultItem, index) => {
    const savedItem = savedClassicWhyCards[index];
    return {
      ...defaultItem,
      ...(typeof savedItem === 'string' ? { title: savedItem } : savedItem || {}),
    };
  });
  const savedModernCourses = savedWebsite?.modernCourses || {};
  website.modernCourses = {
    ...PUBLIC_WEBSITE_DEFAULTS.modernCourses,
    eyebrow: savedModernCourses.eyebrow ?? website.coursesEyebrow,
    title: savedModernCourses.title ?? website.coursesTitle,
    description: savedModernCourses.description ?? website.coursesDescription,
    alignment: savedModernCourses.alignment ?? website.courseAlignment,
    ...savedModernCourses,
  };
  if (!['left', 'center', 'right'].includes(website.modernCourses.alignment)) website.modernCourses.alignment = 'left';
  const savedMinimalCourses = savedWebsite?.minimalCourses || {};
  website.minimalCourses = {
    ...PUBLIC_WEBSITE_DEFAULTS.minimalCourses,
    eyebrow: savedMinimalCourses.eyebrow ?? website.coursesEyebrow,
    title: savedMinimalCourses.title ?? website.coursesTitle,
    description: savedMinimalCourses.description ?? website.coursesDescription,
    alignment: savedMinimalCourses.alignment ?? website.courseAlignment,
    ...savedMinimalCourses,
  };
  if (!['left', 'center', 'right'].includes(website.minimalCourses.alignment)) website.minimalCourses.alignment = 'left';
  const savedClassicContact = savedWebsite?.classicContact || {};
  website.classicContact = {
    ...PUBLIC_WEBSITE_DEFAULTS.classicContact,
    eyebrow: savedClassicContact.eyebrow ?? website.contactEyebrow,
    title: savedClassicContact.title ?? website.contactTitle,
    description: savedClassicContact.description ?? website.contactDescription,
    ctaEyebrow: savedClassicContact.ctaEyebrow ?? website.contactCtaEyebrow,
    ctaTitle: savedClassicContact.ctaTitle ?? website.contactCtaTitle,
    ctaDescription: savedClassicContact.ctaDescription ?? website.contactCtaDescription,
    primaryAction: savedClassicContact.primaryAction ?? website.classicHero.primaryAction,
    secondaryAction: savedClassicContact.secondaryAction ?? website.classicHero.secondaryAction,
    ...savedClassicContact,
  };
  const savedModernContact = savedWebsite?.modernContact || {};
  website.modernContact = {
    ...PUBLIC_WEBSITE_DEFAULTS.modernContact,
    eyebrow: savedModernContact.eyebrow ?? website.contactEyebrow,
    title: savedModernContact.title ?? website.contactTitle,
    description: savedModernContact.description ?? website.contactDescription,
    ctaEyebrow: savedModernContact.ctaEyebrow ?? website.contactCtaEyebrow,
    ctaTitle: savedModernContact.ctaTitle ?? website.contactCtaTitle,
    ctaDescription: savedModernContact.ctaDescription ?? website.contactCtaDescription,
    primaryAction: savedModernContact.primaryAction ?? website.heroPrimaryAction,
    secondaryAction: savedModernContact.secondaryAction ?? website.heroSecondaryAction,
    ...savedModernContact,
  };
  const savedMinimalContact = savedWebsite?.minimalContact || {};
  website.minimalContact = {
    ...PUBLIC_WEBSITE_DEFAULTS.minimalContact,
    eyebrow: savedMinimalContact.eyebrow ?? website.contactEyebrow,
    title: savedMinimalContact.title ?? website.contactTitle,
    description: savedMinimalContact.description ?? website.contactDescription,
    primaryAction: savedMinimalContact.primaryAction ?? website.minimalAbout.primaryAction,
    secondaryAction: savedMinimalContact.secondaryAction ?? website.minimalAbout.secondaryAction,
    ...savedMinimalContact,
  };
  const savedFooter = savedWebsite?.footer || {};
  website.footer = {
    ...PUBLIC_WEBSITE_DEFAULTS.footer,
    eyebrow: savedFooter.eyebrow ?? website.footerEyebrow,
    title: savedFooter.title ?? website.footerTitle,
    description: savedFooter.description ?? website.footerDescription,
    action: savedFooter.action ?? website.footerAction,
    ...savedFooter,
  };
  return website;
}
